import React from 'react';

import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './menu.module.styl';

import type {ComponentPropsWithoutRef} from 'react';


const classnames = withCssModule(styles);

type NativeProps = ComponentPropsWithoutRef<'div'>;

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Props extends NativeProps {}

/**
 * List component.
 * Renders a list of menu items.
 */
export function List({
    children,
    ...rootProps
}: Props) {
    return (
        <div
            role="menu"
            {...rootProps}
            className={classnames('list', rootProps?.className)}>
            {children}
        </div>
    );
}
